import { render, staticRenderFns } from "./settlement-payment.vue?vue&type=template&id=2e0dcaac&scoped=true"
import script from "./settlement-payment.vue?vue&type=script&lang=js"
export * from "./settlement-payment.vue?vue&type=script&lang=js"
import style0 from "./settlement-payment.vue?vue&type=style&index=0&id=2e0dcaac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0dcaac",
  null
  
)

export default component.exports